import script from "./MainComp.vue?vue&type=script&setup=true&lang=js"
export * from "./MainComp.vue?vue&type=script&setup=true&lang=js"

import "./MainComp.vue?vue&type=style&index=0&id=368bb0f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368bb0f1"]])

export default __exports__